export default "__VITE_ASSET__C3njM79p__"